import React, { useState } from 'react';
import { Container, Row, Col, Button, Form, Modal} from 'react-bootstrap';
import '../styles/PricingSection.css';
import emailjs from 'emailjs-com';



interface QuoteFormData {
    name: string;
    email: string;
    company: string;
    plan: string;
    [key: string]: string;
}
const PricingSection: React.FC = () => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [formData, setFormData] = useState<QuoteFormData>({
        name: '',
        email: '',
        company: '',
        plan: '',
    });
    const handleChange = (e:any) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        emailjs.send(
            'service_shxee7t',
            'template_gizbqr3',
            formData,
            '4ZdLv43nxojS47a_z'
        ).then(() => {
            setFormData({ name: '', email: '', company: '', plan: 'Starter' });
            setShowModal(false);
        }).catch((error:any) => {
            console.error('Error sending email:', error);
        });
    };
    return (
        <Container fluid >
            <Row className="align-items-center">
                <Col md={5} className="text-center text-md-left">
                    <h2>Affordable Plans for Everyone</h2>
                    <div className="pricing-card mt-5">
                        {/*<h3 style={{color:'#D2302F'}}>$270</h3>*/}
                        <h6><span className="fw-bold">Starter - </span>10,000 min of transcription </h6>
                        {/*<p>Extra minutes: $0.03 USD/min</p>*/}
                    </div>
                    <div className="pricing-card mt-5">
                        {/*<h3 style={{color:'#D2302F'}}>$920</h3>*/}
                        <h6><span className="fw-bold">Pro -</span> 50,000 min of transcription </h6>
                        {/*<p>Extra minutes: $0.02 USD/min</p>*/}
                    </div>
                    <div className="pricing-card mt-5">
                        <h6 style={{color:'#D2302F'}}>Custom Quote</h6>
                        <h6><span className="fw-bold">Enterprise -</span> +100,000 min of transcription </h6>
                    </div>
                    <Button variant="contained" onClick={()=>{setShowModal(true)}} className="px-4 mt-2" style={{ backgroundColor: '#e53935', color: '#fff' }}>Request a quotation</Button>
                </Col>
                <Col md={7}>
                    <img src="PricingSection.jpg" alt="Transcription Service" className="img-fluid" />
                </Col>
            </Row>
            {/* Quote Request Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Request a Quotation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="name">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="company">
                            <Form.Label>Company</Form.Label>
                            <Form.Control
                                type="text"
                                name="company"
                                value={formData.company}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="plan">
                            <Form.Label>Choose Plan</Form.Label>
                            <Form.Select
                                name="plan"
                                value={formData.plan}
                                onChange={handleChange}
                                required
                            >
                                <option value="100,000:500,000">100,000 - 500,000 min</option>
                                <option value="500,000:1,000,000">500,000 - 1,000,000 min</option>
                                <option value="+1,000,000">above 1,000,000 min</option>
                            </Form.Select>
                        </Form.Group>
                        <div className="text-end mt-3">
                            <Button type="submit" style={{ backgroundColor: '#e53935', color: '#fff' }}>
                                Send Request
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default PricingSection;